﻿var graphAnimation = (function () {
    var charts;

    var animateOnVisible = function () {
        charts = [].slice.call(document.querySelectorAll(".pod--chart__bars, .strategy-item__chart-placeholder"));
        console.log("charts", charts);
        if ("IntersectionObserver" in window) {
            let chartObserver = new IntersectionObserver(function (entries, observer) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        //console.log("Intersecting", entry);
                        // get all rect with class .bar and apply the animation class
                        var bars = [].slice.call(entry.target.querySelectorAll(".bar"));
                        var time = 50, inc = 70;
                        bars.forEach(function (bar) {
                            setTimeout(
                                function () {
                                    var w = bar.getAttribute('mh:width');
                                    bar.setAttribute("width", w);
                                    bar.classList.add("bar--animate");
                                }, time);
                            time += inc;
                            inc += 10;
                        });
                        chartObserver.unobserve(entry.target);
                    }
                });
            });
            charts.forEach(function (chart) {
                chartObserver.observe(chart);
            });
        } else {
            //fall back - no animations, just set the bars to the appropriate widths
            var bars = [].slice.call(entry.target.querySelectorAll(".bar"));
            bars.forEach(function (bar) {
                var w = bar.getAttribute('mh:width');
                bar.setAttribute("width", w);
            });
        }
    }

    return {
        init: function () {
            console.log("Called graphanimation!");
            animateOnVisible();
        }
    };
})();

$(document).ready(function () {
    graphAnimation.init();
});